import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import {onMounted} from "vue";
import { ConfigProvider } from "ant-design-vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  dayjs.locale("zh-cn");
  onMounted(() => {
    console.log(process.env.VUE_APP_BASE_API)
    localStorage.removeItem("UNIFIED_CONTROL_ERROR_MODAL")
    localStorage.removeItem("COMFIRM_TIMEOUT")
  })

	// const debounce = (callback: (...args: any[]) => void, delay: number) => {
	// 	let tid: any;
	// 	return function(...args: any[]) {
	// 		const ctx = self;
	// 		tid && clearTimeout(tid);
	// 		tid = setTimeout(() => {
	// 			callback.apply(ctx, args);
	// 		}, delay);
	// 	}
	// }

	// const _ = (window as any).ResizeObserver;
	// (window as any).ResizeObserver = class ResizeObserver extends _ {
	// 	constructor(callback: (...args: any[]) => void) {
	// 		callback = debounce(callback, 20);
	// 		super(callback);
	// 	}
	// }


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})